export default "__VITE_PUBLIC_ASSET__ab6fba2f__"